document.addEventListener("DOMContentLoaded", () => {
	const MAX_FILES = 10;

	/**
	 * Format file size
	 */
	const formatFileSize = (bytes) => {
		if (bytes === 0) return "0 Б";
		const k = 1024;
		const sizes = ["Б", "КБ", "МБ", "ГБ"];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
	};

	/**
	 * Get loading files
	 */
	const getCurrentFilesCount = () => {
		const container = document.querySelector("#mfcf7_zl_multifilecontainer");
		if (!container) return 0;

		const fileNames = container.querySelectorAll(".mfcf7-zl-multifile-name");
		return Array.from(fileNames).filter(
			(el) => el.textContent.trim().length > 0
		).length;
	};

	/**
	 * Add file sizes to newly added file rows
	 */
	const addFileSizesToRow = (row) => {
		const fileNameSpan = row.querySelector(".mfcf7-zl-multifile-name");
		if (!fileNameSpan) return;

		const existingSizeSpan = fileNameSpan.querySelector(".file-size");
		if (existingSizeSpan) return;

		const input = row.querySelector("input[type='file']");
		if (!input || !input.files || input.files.length === 0) return;

		const files = Array.from(input.files);
		const fileSizes = files.map(file => formatFileSize(file.size));
		
		const sizeSpan = document.createElement("span");
		sizeSpan.className = "file-size";
		
		if (files.length > 1) {
			sizeSpan.textContent = " | " + fileSizes.join(" | ");
		} else {
			sizeSpan.textContent = " " + fileSizes[0];
		}
		
		fileNameSpan.appendChild(sizeSpan);
	};

	/**
	 * Change limit files
	 */
	const handleFileChange = (e) => {
		const input = e.target;
		if (!input.matches('input[type="file"]')) return;

		const files = input.files;
		if (!files || files.length === 0) return;

		const currentCount = getCurrentFilesCount();
		const availableSlots = MAX_FILES - currentCount;

		if (availableSlots <= 0) {
			input.value = "";
			return;
		}

		if (files.length > availableSlots) {
			const limitedFiles = Array.from(files).slice(0, availableSlots);
			const dataTransfer = new DataTransfer();

			limitedFiles.forEach((file) => {
				dataTransfer.items.add(file);
			});

			input.files = dataTransfer.files;
		}
	};

	/**
	 * Split a lot of files on items
	 * @param {HTMLElement} fileRow - Parent element <p> with files
	 */
	const splitMultipleFiles = (fileRow) => {
		const originalInput = fileRow.querySelector("input[type='file']");
		if (!originalInput || !originalInput.files || originalInput.files.length < 2) return;

		const container = document.querySelector("#mfcf7_zl_multifilecontainer");
		if (!container) return;

		const sampleElement = container.querySelector(".mfcf7-zl-multiline-sample");
		if (!sampleElement) return;

		const sampleTemplate = sampleElement.querySelector("p");
		if (!sampleTemplate) return;

		const files = Array.from(originalInput.files);
		const parentElement = fileRow.parentNode;

		files.forEach((file) => {
			const newRow = sampleTemplate.cloneNode(true);

			const newInput = newRow.querySelector("input[type='file']");
			if (newInput) {
				newInput.style.display = "none";
				newInput.name = originalInput.name;
				newInput.className = originalInput.className;
				newInput.setAttribute("aria-invalid", originalInput.getAttribute("aria-invalid") || "false");

				// Строка клонируется из пустого шаблона, а исходная строка ниже
				// удаляется — значит файл нужно перенести в инпут новой строки.
				// Без этого в $_FILES не уходило ничего: список файлов на экране
				// был, а письмо приходило без архива.
				const dataTransfer = new DataTransfer();
				dataTransfer.items.add(file);
				newInput.files = dataTransfer.files;
			}

			const newFileNameSpan = newRow.querySelector(".mfcf7-zl-multifile-name");
			if (newFileNameSpan) {
				// Очищаем содержимое
				newFileNameSpan.innerHTML = "";

				const fileNameText = document.createTextNode(file.name);
				newFileNameSpan.appendChild(fileNameText);

				const sizeSpan = document.createElement("span");
				sizeSpan.className = "file-size file-size--position";
				sizeSpan.textContent = ` ${formatFileSize(file.size)}`;
				newFileNameSpan.appendChild(sizeSpan);
			}

			parentElement.insertBefore(newRow, fileRow);
		});

		fileRow.remove();
	}

	/**
	 * Check all lines with files
	 */
	const processAllFileRows = () => {
		const fileNameSpans = document.querySelectorAll(".mfcf7-zl-multifile-name");
		
		const fileRowsSet = new Set();
		fileNameSpans.forEach((span) => {
			const row = span.closest(".wpcf7-form-control-wrap");
			if (row) {
				fileRowsSet.add(row);
			}
		});

		fileRowsSet.forEach((row) => {
			addFileSizesToRow(row);
			splitMultipleFiles(row);
		});
	}

	/**
	 * Handle file deletion
	 */
	const handleFileDelete = (e) => {
		const deleteButton = e.target.closest(".mfcf7_zl_delete_file");
		if (!deleteButton) return;

		e.preventDefault();
		
		const fileRow = deleteButton.closest(".wpcf7-form-control-wrap");
		if (fileRow) {
			fileRow.remove();
		}
	};

	processAllFileRows();

	const container = document.querySelector("#mfcf7_zl_multifilecontainer");
	const form = document.querySelector(".wpcf7");
	
	if (container || form) {
		const targetElement = container || form;
		
		const observer = new MutationObserver(() => {
			processAllFileRows();
		});

		observer.observe(targetElement, {
			childList: true,
			subtree: true,
		});
	}

	if (container) {
		container.addEventListener("change", handleFileChange, true);
		container.addEventListener("click", handleFileDelete, true);
	}
});

